export function dataDetailMapper(contact) {
  return {
    ...contact,
    civilite: '',
    portable: '',
    fax: '',
    actif: !contact.archive,
    adrLibelle1: contact.adresse && contact.adresse.adresse1 || '',
    adrLibelle2: contact.adresse && contact.adresse.adresse2 || '',
    adrLibelle3: contact.adresse && contact.adresse.adresse3 || '',
    ville: contact.adresse && contact.adresse.ville || '',
    cp: contact.adresse && contact.adresse.codePostal || '',
  };
}
export function mapContactsResponse(gescomResponse) {
  const { result } = gescomResponse.data;
  const items = result.items || [];

  return items.map((contact) => ({
    ...contact,
    typeContactId: contact.typesContactIds && contact.typesContactIds[0] ? contact.typesContactIds[0] : null,
  }));
}